
const Loader = (props)=>{
    const { isOpen } = props;
    return (
        <div id="cover-spin" style={{display: isOpen ? 'block' : 'none' }}></div>
    )
}
export default Loader;